import styled from 'styled-components';

export const FormElementHint = styled.div`
  font-size: 12px;
  margin-top: 5px;
  color: ${({ theme }) => theme.osloGray};
`;
